module.exports = __webpack_public_path__ + "c0c498ea6855a14125641136a80c2569.svg";